import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { MedicationGroup, MedsOfInterestFilter, MedsOfInterestResponse } from '../../models/medication-group';
import { NursingAuditService } from "src/app/services/nursing-audit.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-med-table',
  templateUrl: './med-table.component.html',
  styleUrls: ['./med-table.component.scss'],
  standalone: false
})
export class MedTableComponent implements OnInit {
  private readonly auditService = inject(NursingAuditService);

  assayManagementEnabled = environment.enableAssayManagement;
  @Output() rowSelected = new EventEmitter<MedicationGroup>();
  filter: MedsOfInterestFilter = {};

  medicationData: MedicationGroup[] = [];
  fullMedicationData: MedicationGroup[] = [];
  globalSearch = '';
  ngOnInit(): void {
    this.auditService.getMonitoredMedsOfInterest(this.filter).subscribe((res) => {
      this.loadMedications(res);
    });
  }

  loadMedications(res: MedsOfInterestResponse): void {
    this.fullMedicationData = res.medicationData || [];
    this.medicationData = [...this.fullMedicationData];
  }

  onSearchInput(): void {
    this.applyFilters();
  }

  private applyFilters(): void {
    let data = [...this.fullMedicationData];

    const search = (this.globalSearch || '').trim().toLowerCase();
    if (search) {
      data = data.filter(m =>
        m.medGroupName?.toLowerCase().includes(search)
      );
    }

    this.medicationData = data;
  }

  onRowActivate(med: MedicationGroup): void {
    this.rowSelected.emit(med);
  }

  getWeightLabel(weight: number): string {
    if (weight >= 8) return 'High';
    if (weight >= 5) return 'Medium';
    return 'Low';
  }

  getTotalMappedItems(med: MedicationGroup): number {
    return (med.mappedItems || med.medDescription || []).length;
  }
}
